import {
  SIP_TRACE_START_REQUEST,
  SIP_TRACE_START_SUCCESS,
  SIP_TRACE_START_FAIL,
  SIP_TRACE_STOP_REQUEST,
  SIP_TRACE_STOP_SUCCESS,
  SIP_TRACE_STOP_FAIL,
  SIP_TRACE_STATUS_REQUEST,
  SIP_TRACE_STATUS_SUCCESS,
  SIP_TRACE_STATUS_FAIL,
  SIP_TRACE_MESSAGES_REQUEST,
  SIP_TRACE_MESSAGES_SUCCESS,
  SIP_TRACE_MESSAGES_FAIL,
  SIP_TRACE_CALL_MESSAGES_REQUEST,
  SIP_TRACE_CALL_MESSAGES_SUCCESS,
  SIP_TRACE_CALL_MESSAGES_FAIL,
  SIP_TRACE_ERRORS_REQUEST,
  SIP_TRACE_ERRORS_SUCCESS,
  SIP_TRACE_ERRORS_FAIL,
  SIP_TRACE_MESSAGE_DETAIL_REQUEST,
  SIP_TRACE_MESSAGE_DETAIL_SUCCESS,
  SIP_TRACE_MESSAGE_DETAIL_FAIL,
  SIP_TRACE_NEW_MESSAGE,
  SIP_TRACE_BATCH_MESSAGES,
  SIP_TRACE_STATS_UPDATE,
  SIP_TRACE_CAPTURE_STOPPED,
  SIP_TRACE_CLEAR,
} from "../constants/sipTraceConstants";

const initialState = {
  capturing: false,
  loading: false,
  actionLoading: false,
  messages: [],
  callMessages: [],
  errors: [],
  stats: {
    total: 0,
    requests: 0,
    responses: 0,
    errors: 0,
  },
  session: null,
  selectedMessage: null,
  stopReason: null,
  error: null,
};

export const sipTraceReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- Start ---
    case SIP_TRACE_START_REQUEST:
      return { ...state, actionLoading: true, error: null };
    case SIP_TRACE_START_SUCCESS:
      return {
        ...state,
        actionLoading: false,
        capturing: true,
        messages: [],
        errors: [],
        stopReason: null,
        stats: { total: 0, requests: 0, responses: 0, errors: 0 },
      };
    case SIP_TRACE_START_FAIL:
      return { ...state, actionLoading: false, error: action.payload };

    // --- Stop ---
    case SIP_TRACE_STOP_REQUEST:
      return { ...state, actionLoading: true };
    case SIP_TRACE_STOP_SUCCESS:
      return { ...state, actionLoading: false, capturing: false, stopReason: "manual" };
    case SIP_TRACE_STOP_FAIL:
      return { ...state, actionLoading: false, error: action.payload };

    // --- Status ---
    case SIP_TRACE_STATUS_REQUEST:
      return { ...state, loading: true };
    case SIP_TRACE_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        capturing: action.payload?.state === "capturing",
        stats: action.payload?.stats || state.stats,
        session: action.payload?.session || state.session,
      };
    case SIP_TRACE_STATUS_FAIL:
      return { ...state, loading: false, error: action.payload };

    // --- Messages ---
    case SIP_TRACE_MESSAGES_REQUEST:
      return { ...state, loading: true };
    case SIP_TRACE_MESSAGES_SUCCESS:
      return { ...state, loading: false, messages: action.payload };
    case SIP_TRACE_MESSAGES_FAIL:
      return { ...state, loading: false, error: action.payload };

    // --- Call Messages (ladder) ---
    case SIP_TRACE_CALL_MESSAGES_REQUEST:
      return { ...state, loading: true };
    case SIP_TRACE_CALL_MESSAGES_SUCCESS:
      return { ...state, loading: false, callMessages: action.payload };
    case SIP_TRACE_CALL_MESSAGES_FAIL:
      return { ...state, loading: false, error: action.payload };

    // --- Errors ---
    case SIP_TRACE_ERRORS_REQUEST:
      return { ...state, loading: true };
    case SIP_TRACE_ERRORS_SUCCESS:
      return { ...state, loading: false, errors: action.payload };
    case SIP_TRACE_ERRORS_FAIL:
      return { ...state, loading: false, error: action.payload };

    // --- Message Detail ---
    case SIP_TRACE_MESSAGE_DETAIL_REQUEST:
      return { ...state, loading: true };
    case SIP_TRACE_MESSAGE_DETAIL_SUCCESS:
      return { ...state, loading: false, selectedMessage: action.payload };
    case SIP_TRACE_MESSAGE_DETAIL_FAIL:
      return { ...state, loading: false, error: action.payload };

    // --- Real-time SocketIO events ---
    case SIP_TRACE_NEW_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };

    case SIP_TRACE_BATCH_MESSAGES:
      return {
        ...state,
        messages: [...state.messages, ...action.payload],
      };

    case SIP_TRACE_STATS_UPDATE:
      return {
        ...state,
        stats: {
          ...state.stats,
          ...action.payload,
        },
      };

    case SIP_TRACE_CAPTURE_STOPPED:
      return {
        ...state,
        capturing: false,
        stopReason: action.payload,
      };

    // --- Clear ---
    case SIP_TRACE_CLEAR:
      return { ...initialState };

    default:
      return state;
  }
};
